export default "__VITE_ASSET__B3MqYnQU__"